import React, { useState } from "react";
import { StyleSheet, Text, View, TouchableOpacity, Platform } from "react-native";
import * as Clipboard from "expo-clipboard";
import Colours from "../utils/Colours";
import QuestionMark from "../icons/QuestionMark";
import { Ionicons } from "@expo/vector-icons";

const WordNotice = ({ message, onClose, tagLink = null, title = "About" }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    if (tagLink) {
      await Clipboard.setStringAsync(tagLink);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // revert after 2s
    }
  };

  //11111111
  // const handleCopy = () => {
  //   if (!tagLink) return;

  //   try {
  //     // 1. Handle Web PWA contexts (Mobile Safari / iOS Chrome / Desktop)
  //     if (Platform.OS === "web") {
  //       if (typeof ClipboardItem !== "undefined" && navigator.clipboard) {
  //         // Safari requires wrapping the text in a synchronized Promise Blob via ClipboardItem
  //         const textBlob = new Blob([tagLink], { type: "text/plain" });
  //         const item = new ClipboardItem({ "text/plain": Promise.resolve(textBlob) });

  //         navigator.clipboard
  //           .write([item])
  //           .then(() => triggerCopySuccess())
  //           .catch((err) => console.error("Safari write failed", err));
  //       } else {
  //         // Clean synchronous DOM Textarea fallback if Clipboard API isn't supported
  //         const textArea = document.createElement("textarea");
  //         textArea.value = tagLink;
  //         textArea.style.position = "fixed";
  //         textArea.style.opacity = "0";
  //         document.body.appendChild(textArea);
  //         textArea.focus();
  //         textArea.select();
  //         try {
  //           document.execCommand("copy");
  //           triggerCopySuccess();
  //         } catch (err) {
  //           console.error("Fallback script copy failed", err);
  //         }
  //         document.body.removeChild(textArea);
  //       }
  //     } else {
  //       // 2. Handle Native Apps (iOS/Android IPA/APK installs)
  //       Clipboard.setStringAsync(tagLink).then(() => triggerCopySuccess());
  //     }
  //   } catch (error) {
  //     console.error("Failed to copy text: ", error);
  //   }
  // };

  //2222222222222
  // const handleCopy = async () => {
  //   if (!tagLink) return;

  //   try {
  //     if (Platform.OS === "web") {
  //       // Check for writeText first — it's synchronous enough for Safari PWA
  //       // and avoids the ClipboardItem Promise wrapping issue entirely
  //       if (navigator.clipboard && navigator.clipboard.writeText) {
  //         await navigator.clipboard.writeText(tagLink);
  //         triggerCopySuccess();
  //       } else {
  //         // DOM textarea fallback for older browsers
  //         const textArea = document.createElement("textarea");
  //         textArea.value = tagLink;
  //         textArea.style.cssText = "position:fixed;top:0;left:0;opacity:0;pointer-events:none;";
  //         document.body.appendChild(textArea);
  //         textArea.focus();
  //         textArea.select();
  //         const success = document.execCommand("copy");
  //         document.body.removeChild(textArea);
  //         if (success) triggerCopySuccess();
  //       }
  //     } else {
  //       await Clipboard.setStringAsync(tagLink);
  //       triggerCopySuccess();
  //     }
  //   } catch (error) {
  //     // Final fallback — execCommand for stubborn Safari contexts
  //     try {
  //       const textArea = document.createElement("textarea");
  //       textArea.value = tagLink;
  //       textArea.style.cssText = "position:fixed;top:0;left:0;opacity:0;pointer-events:none;";
  //       document.body.appendChild(textArea);
  //       textArea.focus();
  //       textArea.select();
  //       document.execCommand("copy");
  //       document.body.removeChild(textArea);
  //       triggerCopySuccess();
  //     } catch (fallbackError) {
  //       console.error("All copy methods failed:", fallbackError);
  //     }
  //   }
  // };

  //333333333333
  // const handleCopy = () => {
  //   if (!tagLink) return;

  //   if (Platform.OS === "web") {
  //     // iOS Safari & Chrome PWA: must be 100% synchronous inside the tap handler
  //     // Any await/Promise before execCommand breaks the gesture chain on iOS
  //     const textArea = document.createElement("textarea");
  //     textArea.value = tagLink;

  //     // These styles are critical for iOS — it must be rendered,
  //     // editable, and within the viewport to allow selection
  //     textArea.style.cssText = `
  //     position: fixed;
  //     top: 50%;
  //     left: 50%;
  //     width: 2em;
  //     height: 2em;
  //     margin: -1em 0 0 -1em;
  //     border: none;
  //     outline: none;
  //     background: transparent;
  //     font-size: 16px;
  //   `;
  //     // font-size: 16px prevents iOS auto-zoom on focus

  //     document.body.appendChild(textArea);
  //     textArea.focus();

  //     // iOS-specific selection
  //     if (navigator.userAgent.match(/ipad|iphone/i)) {
  //       const range = document.createRange();
  //       range.selectNodeContents(textArea);
  //       const selection = window.getSelection();
  //       selection.removeAllRanges();
  //       selection.addRange(range);
  //       textArea.setSelectionRange(0, 999999);
  //     } else {
  //       textArea.select();
  //     }

  //     try {
  //       document.execCommand("copy");
  //       triggerCopySuccess();
  //     } catch (err) {
  //       console.error("execCommand copy failed:", err);
  //     }

  //     document.body.removeChild(textArea);
  //   } else {
  //     // Native iOS/Android app — expo-clipboard works fine here
  //     Clipboard.setStringAsync(tagLink).then(() => triggerCopySuccess());
  //   }
  // };

  const triggerCopySuccess = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 2000); // revert after 2s
  };

  return (
    <View style={styles.modalOverlay}>
      <View style={styles.modalContainer}>
        {/* DYNAMIC TOP ICON SELECTION */}
        {tagLink ? (
          <View style={styles.iconBadgeWrapper}>
            <Ionicons name="people-outline" size={40} color={Colours.PRIMARY} />
          </View>
        ) : (
          <QuestionMark height={40} width={40} color={Colours.PRIMARY} />
        )}

        <Text style={styles.successTitle}>{title}</Text>
        <Text style={styles.successMessage}>{message}</Text>

        {/* Optional link section */}
        {tagLink && (
          <View style={styles.linkContainer}>
            <Text style={styles.linkText} numberOfLines={1}>
              {tagLink}
            </Text>

            <TouchableOpacity style={styles.copyButton} onPress={handleCopy} activeOpacity={0.7}>
              <Ionicons
                name={copied ? "checkmark-circle" : "copy-outline"}
                size={20}
                color={copied ? "green" : Colours.PRIMARY}
              />
              <Text style={[styles.copyText, copied && { color: "green" }]}>
                {copied ? "Copied!" : "Copy"}
              </Text>
            </TouchableOpacity>
          </View>
        )}

        <TouchableOpacity style={styles.closeButton} onPress={onClose}>
          <Text style={styles.closeButtonText}>Ok</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

export default WordNotice;

const styles = StyleSheet.create({
  modalOverlay: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  modalContainer: {
    width: "90%",
    padding: 20,
    backgroundColor: "white",
    borderRadius: 10,
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  /* Added to give the vector invitation icon uniform sizing constraints */
  iconBadgeWrapper: {
    height: 40,
    width: 40,
    alignItems: "center",
    justifyContent: "center",
  },
  successTitle: {
    fontSize: 20,
    fontWeight: "bold",
    color: Colours.PRIMARY,
    marginBottom: 10,
    fontFamily: "Sen-Regular",
    marginTop: 10, // Added small top spacer below the swapped icon
  },
  successMessage: {
    fontSize: 16,
    color: "#333",
    textAlign: "center",
    marginBottom: 20,
    marginTop: 10,
    fontFamily: "Sen-Regular",
  },
  linkContainer: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#f7f7f7",
    padding: 10,
    borderRadius: 8,
    width: "100%",
    justifyContent: "space-between",
    marginBottom: 20,
  },
  linkText: {
    flex: 1,
    color: Colours.PRIMARY,
    fontFamily: "Sen-Regular",
    marginRight: 10,
  },
  copyButton: {
    flexDirection: "row",
    alignItems: "center",
    gap: 5,
  },
  copyText: {
    color: Colours.PRIMARY,
    fontFamily: "Sen-Regular",
    fontSize: 14,
  },
  closeButton: {
    backgroundColor: Colours.PRIMARY,
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 10,
  },
  closeButtonText: {
    color: "white",
    fontWeight: "bold",
    fontSize: 15,
    fontFamily: "Sen-Regular",
  },
});
